import professional_svg from "../resources/svg/professional.svg"

function ProfessionalIcon() {
    return (
        <div className={"p-2 bg-blue-300 w-fit rounded-full"}>
            <img width={35} src={professional_svg} />
        </div>
    )
}

export default ProfessionalIcon
